export default (previousState = 'es', { type, payload }) => {
  if (type === 'SET_LANG') {
    return payload.lang
  }
  return previousState
}
